var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-class-builder-placeholder"},[_c('main',[_c('ed-class-schedule-header',{on:{"onBack":_vm.emitOnBack}},[[_c('aside',[_c('h2',[_vm._v(_vm._s(_vm.classDetail.className))]),_c('p',[_vm._v(_vm._s(_vm.$t('classes.calendar.title')))])])]],2),_c('ed-class-builder-placeholder-calendar',{attrs:{"scheduleDetails":_vm.scheduleDetails},on:{"zoom":function (ref) {
	var weekday = ref.weekday;
	var start = ref.start;
	var end = ref.end;

	return _vm.handleZoom(weekday, start, end);
}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }